function StateMachine(context, payload) {
	this.states = {};
	this.transitions = {};
	this.current = "";
	this.context = context;
	this.payload = payload;
}

StateMachine.prototype = {
	
	addState: function(name, behavior) {
		this.states[name] = {"behavior": behavior};
		if (this.current == "") this.current = {"state": name, "extra": {}};
	},

	transit: function(state, key, next, extra) {
		if (this.transitions[state] == undefined) this.transitions[state] = {};
		this.transitions[state][key] = {"state": next, "extra": extra};
	},

	process: function() {
		if (this.current == "") return;

		var action = this.states[this.current.state].behavior.handle.bind(this.context);
		var result = action(this, this.payload, this.current.extra);

		if (result != null) {
			try {
				var next = this.transitions[this.current.state][result];
				if (next != undefined) this.current = next;
			} catch(e) {
				this.current = "";
			}
		}
	},

	
}